// **من الإشعار إلى الموضوع نفسه** (قرار المالك 04/10/2026: «لما يظهر اشعار ان ف حاجه جديده تم اضافتها فى دليلك للسياحة عاوز
// لما يشوفها من الاشعار ويضغط عليها توديه عليها علطول»).
//
// نفس منطق openIntent: الطلب يُترك في تخزين الجلسة ويُبثّ حدث، والانتقال للتاب بالعنوان (#guide). وشاشة الدليل تلتقطه عند
// تركيبها (لم تكن مفتوحة) أو تسمع الحدث (كانت مفتوحة)، فتمسح البحث والتصنيف وتفتح الموضوع وتنزل إليه — ثم يُمحى الطلب.
const KEY = 'icontravel.guide.focus';
export const GUIDE_FOCUS_EVENT = 'icontravel:guide-focus';

export function openGuideArticle(articleId: string): void {
  try { window.sessionStorage.setItem(KEY, articleId); } catch { /* تصفّح خاص: يبقى الحدث */ }
  try { window.dispatchEvent(new CustomEvent(GUIDE_FOCUS_EVENT, { detail: articleId })); } catch { /* */ }
  try { if (window.location.hash !== '#guide') window.location.hash = 'guide'; } catch { /* */ }
}

/**
 * **إشعار الموبايل** يصل بعنوان `#guide/<id>` (web-push.ts): يُحوَّل هنا إلى طلب فتح الموضوع، ويُستبدل العنوان بـ`#guide`
 * **استبدالًا** لا خطوةً جديدة — فـ«رجوع» بعدها لا يرجع إلى `#guide/<id>` فيفتح الموضوع من جديد في حلقة.
 * يُركَّب مرّةً في main.tsx: يقرأ العنوان عند الفتح، ويسمع كل تغيير بعده (ضغطةٌ على إشعار والبرنامج مفتوح).
 */
export function installGuideLinks(): void {
  const take = () => {
    const m = /^#guide\/([0-9a-f-]{36})$/i.exec(window.location.hash);
    if (!m) return;
    try { window.sessionStorage.setItem(KEY, m[1]); } catch { /* */ }
    try { window.dispatchEvent(new CustomEvent(GUIDE_FOCUS_EVENT, { detail: m[1] })); } catch { /* */ }
    try {
      window.history.replaceState(window.history.state, '', '#guide');
      window.dispatchEvent(new HashChangeEvent('hashchange'));
    } catch { /* */ }
  };
  take();
  window.addEventListener('hashchange', take);
}

/** الموضوع المطلوب فتحه — ويُمحى بقراءته، فلا يفتحه تحديث الصفحة من جديد */
export function takeGuideFocus(): string | null {
  try {
    const v = window.sessionStorage.getItem(KEY);
    if (v) window.sessionStorage.removeItem(KEY);
    return v;
  } catch { return null; }
}
